/**
 * Прилипание прямых к горизонтали и вертикали.
 *
 * С Shift штрих пера и «Прямая» становятся ровным отрезком, и если угол
 * меньше 5° от горизонтали или вертикали, отрезок выравнивается по ней.
 * Это мешает, когда нужна линия с небольшим наклоном (график, чертёж):
 * она «срывается» в ровную. Настройка своя у каждого человека, как
 * разлиновка доски, и по умолчанию включена — у остальных ничего не меняется.
 */

const STORAGE_KEY = "wb-line-axis-snap";
const EVENT = "wb-line-axis-snap";

export function lineAxisSnapEnabled(): boolean {
  try {
    return window.localStorage.getItem(STORAGE_KEY) !== "off";
  } catch {
    return true;
  }
}

export function setLineAxisSnapEnabled(on: boolean): void {
  try {
    if (on) window.localStorage.removeItem(STORAGE_KEY);
    else window.localStorage.setItem(STORAGE_KEY, "off");
  } catch {
    /* приватный режим — настройка не переживёт перезагрузку */
  }
  window.dispatchEvent(new Event(EVENT));
}

export function subscribeLineAxisSnap(onChange: () => void): () => void {
  window.addEventListener(EVENT, onChange);
  return () => window.removeEventListener(EVENT, onChange);
}
